import { createGtag, optIn, optOut } from 'vue-gtag';
appHost.plugins.register({
    // #region Vars
    name: "288a.web.gtag",
    // #endregion
    // #region Startup
    startup() {
        if (this.$appHost.config.googleTag && this.$appHost.config.googleTag.id) {
            this.$appHost.app.use(createGtag({
                tagId: appHost.config.googleTag.id,
                pageTracker: {
                    router: this.$appHost.router,
                }
            }));
            if (utils.getCookieValue("288a.CookieStatistik") == "yes") {
                optIn();
            }
            else {
                optOut();
            }
            //Events
            this.$appHost.eventBus.on("cookie_consent_changed", async (e) => {
                //Set
                if (utils.getCookieValue("288a.CookieStatistik") == "yes") {
                    optIn();
                }
                else {
                    optOut();
                }
            });
        }
    }
    // #endregion
});
